// import {
//   Application
// } from "@hotwired/stimulus"
// import {
//   initStimulus
// } from "vite-stimulus-initializer";
// const controllers =
//   import.meta.glob('./**/*_controller.js', {
//     eager: true
//   })
// initStimulus(controllers, 2, {
//   debug: true,
//   exclude: ['components', 'views'],
//   folderSeparator: '-'
// })

console.log('shared application.js')
import {
  isDebugMode,
  debugLog
} from '../debug'

const application = window.Stimulus
application.debug = isDebugMode

import EditProfileController from "./edit_profile_controller"
application.register("edit-profile", EditProfileController)
import OverriderController from "./overrider_controller"
application.register("overrider", OverriderController)
import ModalController from "./modal_controller"
application.register("modal", ModalController)

// import Dialog from '@stimulus-components/dialog'
// application.register('dialog', Dialog)

export {
  application
}